import React              from 'react';
import { makeStyles }     from '@material-ui/core/styles';
import colors             from '../../utils/colors';

const useStyles = makeStyles (() => ({
    root: {
        position:        'fixed',
        left:            '20vw',
        width:           '60vw',
        height:          25,
        display:         'flex',
        borderRadius:    '100em',
        backgroundColor: '#EEF',
        overflow:        'hidden',
      //  border: '1px solid #F00'
     },
     white: {
         backgroundColor: '#EEF',
         transition:      'all 0.6s'
      },
      blue: {
        backgroundColor: colors.blue,
        transition:      'all 0.6s',
        borderRadius:    '100em',
     },
     brightBlue: {
        width:           '70%',
        height:          7,
        marginLeft:      10,
        borderRadius:    '100em',
        marginTop:       5,
        backgroundColor: colors.brightBlue,
        transition:      'all 0.6s'

     }
}))

type ProgressBarProps = {
  size:   number[];
  length: number;
  prog:   number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ size, length, prog }) => {

  const classes = useStyles();
/* 
  console.log('prog    :  ',prog)
  console.log('length  :  ',length) */


  return (
    <div
       className = { classes.root }
       style     = {{
         top: size[1] < 730 ? 5 : 30,
       }}
   >
       <div 
          className = { classes.blue }  
          style     = {{ flex: prog }}
       >
          <div 
             className = { classes.brightBlue }
             style     = {{
                 width: prog ? (((size[0] * 0.6) / length * prog) - 20) : 0
             }}
          />
       </div>
       <div className = { classes.white } style = {{ flex: length - prog }}/>
   </div>
   
  );
}

export default ProgressBar;
